import styled from 'styled-components';

import { mqMedium } from 'styles/breakpoints';

export const StyledFieldset = styled.fieldset`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  margin-right: 1rem;
  gap: 1.25rem;
  width: 100%;

  /*
   * Below md the options stack to full width, which keeps long captions readable
   * and gives a comfortable tap target. From md up they sit in a row and wrap onto
   * the next line instead of overflowing the form column.
   */
  ${mqMedium`
    flex-direction: row;
    flex-wrap: wrap;
  `};
`;
